import React from "react";
import { Skeleton } from "primereact/skeleton";
import { useMediaQuery } from "react-responsive";
import "./ProductSectionsLoading.css";

const ProductSectionsLoading = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <div>
      {[...Array(4)].map((_, i) => (
        <React.Fragment key={i}>
          <Skeleton width="20rem" className="mb-4" />
          <div className={`skeleton-container mb-6 ${isMobile ? "carousel-view" : ""}`}>
            {[...Array(isMobile ? 6 : 4)].map((_, j) => (
              <div key={j} className="product-skeleton-wrapper">
                {isMobile ? (
                  <Skeleton size="10rem" className="product-skeleton" />
                ) : (
                  <Skeleton width="100%" height="30rem" className="product-skeleton" />
                )}
                {isMobile && (
                  <div className="additional-skeletons">
                    <Skeleton width="100%" className="product-skeleton-line" />
                    <Skeleton width="100%" className="product-skeleton-line" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

export default ProductSectionsLoading;
